var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehousesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8714 7.45045C11.8714 8.48397 11.0335 9.32179 10 9.32179C8.96648 9.32179 8.12866 8.51867 8.12866 7.45045C8.12866 6.38222 8.96687 5.5791 10 5.5791C11.0331 5.5791 11.8714 6.4524 11.8714 7.45045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.51465 7.48538C2.51465 3.35166 5.86631 0 10 0C14.1326 0 17.4854 3.35166 17.4854 7.48538C17.4854 9.96268 16.776 10.9738 13.3884 15.8016C12.6497 16.8544 11.7835 18.0888 10.7696 19.5595C10.3981 20.0963 9.60358 20.0963 9.232 19.5595C8.22167 18.0949 7.35807 16.8647 6.621 15.8147C3.22456 10.9764 2.51465 9.96517 2.51465 7.48538ZM6.88112 7.45029C6.88112 9.17037 8.27956 10.5692 10 10.5692C11.7193 10.5692 13.1189 9.17037 13.1189 7.45029C13.1189 5.73021 11.7193 4.33138 10 4.33138C8.28073 4.33138 6.88112 5.73021 6.88112 7.45029Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehousesIcon);
export default __webpack_public_path__ + "static/media/warehouses-icon.8d18d5f77502787f4954b7041c522734.svg";
export { ForwardRef as ReactComponent };